<template>
  <div class="box">
    <div>
      <div><img src="../assets/serach/Illustration.png" alt="" /></div>
      <div class="btn-item">
        <div class="btn" @click="goHome">返回首页</div>
        <div class="btn" @click="goSuperior">返回上一页</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'undevelopedPage',
    methods: {
      goHome() {
        this.$router.push('/dashboard');
      },
      goSuperior() {
        this.$router.go(-1);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .box {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .btn-item {
    padding: 0 270px;
    display: flex;
    justify-content: space-between;
    .btn {
      background-color: #409eff;
      border-radius: 3px;
      height: 30px;
      line-height: 30px;
      width: 100px;
      text-align: center;
      color: #ffffff;
      cursor: pointer;
    }
  }
</style>
